import { LocationStrategy } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppComponent } from './app.component';
import { ValidationComponent } from './components/formulaire/validation/validation.component';
import { InfoAdresseComponent } from './components/info/info-adresse/info-adresse.component';
import { HeadersInterceptor } from './interceptors/headers.interceptor';
import { InfoCarteComponent } from './components/info/info-carte/info-carte.component';
import { DisplayDonneesRefPipe } from './pipes/display-donnees-ref.pipe';
import { SaisieAdresseComponent } from './components/saisie/saisie-adresse/saisie-adresse.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { ValiderCoordonneesComponent } from './components/formulaire/validation/valider-coordonnees/valider-coordonnees.component';
import { AdressePipe } from './pipes/adresse.pipe';
import { AppRoutingModule } from './app-routing.module';
import { ValiderTelephoneComponent } from './components/formulaire/validation/valider-telephone/valider-telephone.component';
import { ModifierHoganComponent } from './components/formulaire/modification-hogan/modifier-hogan.component';
import { DsdLibraryModule } from '@dsd/library-angular';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { ErreurInputComponent } from './components/erreur-input/erreur-input.component';
import { ModaleComponent } from './components/modale/modale.component';
import { SaisieCourrielComponent } from './components/saisie/saisie-courriel/saisie-courriel.component';
import { ValiderCourrielComponent } from './components/formulaire/validation/valider-courriel/valider-courriel.component';
import { ErreurInputTelephoneComponent } from './components/erreur-input-telephone/erreur-input-telephone.component';
import { SaisieTelephoneComponent } from './components/saisie/saisie-telephone/saisie-telephone.component';
import { CodepostalPipe } from './pipes/codepostal.pipe';
import { AccueilHoganComponent } from './components/accueil-hogan/accueil-hogan.component';
import { CustomLocationStrategy } from './services/url/custom-location-strategy';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { DsdPrefetchComponentsComponent } from './components/dsd-prefetch-components/dsd-prefetch-components.component';
import { CybermetrieService } from '@oel/js-cybermetrie';
import { MasquerCartePipe } from './pipes/masquer-carte.pipe';
import { Environment } from 'src/environments/environment.class';
import { environment } from 'src/environments/environment';
import { TRANSLATE_HTTP_LOADER_PROVIDER } from './providers/translate-http-loader.provider';
import { CoordonneesComponent } from './components/coordonnees/coordonnees.component';
import { ModificationCoordonneesComponent } from './components/formulaire/modification-coordonnees/modification-coordonnees.component';
import { BasculeHoganFiservComponent } from './components/bascule-hogan-fiserv/bascule-hogan-fiserv.component';
import { AccueilFiservComponent } from './components/accueil-fiserv/accueil-fiserv.component';
import { BoutonRetourComponent } from './components/bouton-retour/bouton-retour.component';
import { BoutonRetourAccueilComponent } from './components/bouton-retour-accueil/bouton-retour-accueil.component';
import { BoutonRetourParcoursExterneComponent } from './components/bouton-retour-parcours-externe/bouton-retour-parcours-externe.component';

import initializer from './initializer';
import { ModificationTelephoneCreditComponent } from './components/modification/modification-telephone-credit/modification-telephone-credit.component';
import { ModifierFiservComponent } from './components/formulaire/modification-fiserv/modifier-fiserv.component';
import { BlocContactFiservComponent } from './components/bloc-contact-fiserv/bloc-contact-fiserv.component';
import { ModificationCourrielComponent } from './components/modification/modification-courriel/modification-courriel.component';
import { AvertissementModificationPlusieursCourrielsCreditComponent } from './components/modification/avertissement-modification-plusieurs-courriels-credit/avertissement-modification-plusieurs-courriels-credit.component';
import { ModificationAdresseComponent } from './components/modification/modification-adresse/modification-adresse.component';
import { ValidationFiservComponent } from './components/formulaire/validation-fiserv/validation-fiserv.component';
import { PageConfirmationComponent } from './components/page-confirmation/page-confirmation.component';
import { PageErreurComponent } from './components/page-erreur/page-erreur.component';
import { BoutonRetourCoordonneesComponent } from './components/bouton-retour-coordonnees/bouton-retour-coordonnees.component';
import { PageValidationComponent } from './components/page-validation/page-validation.component';
import { PhonePipe } from './pipes/phone.pipe';
import { InfoProfilCaisseFolioComponent } from './components/info/info-profil-caisse-folio/info-profil-caisse-folio.component';
import { DateCustomPipe } from './pipes/dateCustom.pipe';

@NgModule({
  declarations: [
    AdressePipe,
    DateCustomPipe,
    PhonePipe,
    DisplayDonneesRefPipe,
    BasculeHoganFiservComponent,
    AccueilHoganComponent,
    AccueilFiservComponent,
    CodepostalPipe,
    AppComponent,
    SaisieAdresseComponent,
    SaisieCourrielComponent,
    SaisieTelephoneComponent,
    DisplayDonneesRefPipe,
    InfoCarteComponent,
    InfoProfilCaisseFolioComponent,
    ModifierHoganComponent,
    ModifierFiservComponent,
    ValidationComponent,
    ValiderCoordonneesComponent,
    ValiderTelephoneComponent,
    InfoAdresseComponent,
    ErreurInputComponent,
    SpinnerComponent,
    ModaleComponent,
    ValiderCourrielComponent,
    ErreurInputTelephoneComponent,
    DsdPrefetchComponentsComponent,
    MasquerCartePipe,
    CoordonneesComponent,
    ModificationCoordonneesComponent,
    BoutonRetourComponent,
    BoutonRetourAccueilComponent,
    BoutonRetourCoordonneesComponent,
    BoutonRetourParcoursExterneComponent,
    ModificationTelephoneCreditComponent,
    BlocContactFiservComponent,
    ModificationCourrielComponent,
    AvertissementModificationPlusieursCourrielsCreditComponent,
    ModificationAdresseComponent,
    ValidationFiservComponent,
    PageConfirmationComponent,
    PageErreurComponent,
    PageValidationComponent,
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    AppRoutingModule,
    BrowserModule,
    ReactiveFormsModule,
    FormsModule,
    DsdLibraryModule.forRoot(),
    NgIdleKeepaliveModule.forRoot(),
    TranslateModule.forRoot({
      loader: TRANSLATE_HTTP_LOADER_PROVIDER,
    }),
  ],
  providers: [
    ...initializer,
    AdressePipe,
    DateCustomPipe,
    PhonePipe,
    CybermetrieService,
    DisplayDonneesRefPipe,
    TranslatePipe,
    {
      provide: LocationStrategy,
      useClass: CustomLocationStrategy,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HeadersInterceptor,
      multi: true,
    },
    {
      provide: Environment,
      useValue: environment,
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
